import { render, staticRenderFns } from "./issuerMessage.vue?vue&type=template&id=4a954bc2&scoped=true&"
import script from "./issuerMessage.vue?vue&type=script&lang=js&"
export * from "./issuerMessage.vue?vue&type=script&lang=js&"
import style0 from "./issuerMessage.vue?vue&type=style&index=0&id=4a954bc2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a954bc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a954bc2')) {
      api.createRecord('4a954bc2', component.options)
    } else {
      api.reload('4a954bc2', component.options)
    }
    module.hot.accept("./issuerMessage.vue?vue&type=template&id=4a954bc2&scoped=true&", function () {
      api.rerender('4a954bc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/shortResume/issuerMessage/issuerMessage.vue"
export default component.exports